import { Routes } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { denominationGuard } from './guards/denomination.guard';
import { pettyCashGuard } from './guards/petty-cash.guard';
import { CashDenominationComponent } from './cash-denomination/cash-denomination.component';
import { CashManagementComponent } from './cash-management/cash-management.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { PdfTemplateTesterComponent } from './pdf-template-tester/pdf-template-tester.component';
import { PettyCashComponent } from './petty-cash/petty-cash.component';

export const routes: Routes = [
    {
        path: '', component: DashboardComponent
    },
    {
        path: 'dashboard', component: DashboardComponent
    },
    {
        path: 'sso-login', component: LoginComponent
    },
    {
        path: 'sales', component: DashboardComponent, canActivate: [AuthGuard]
    },
    {
        path: 'petty-cash',
        component: PettyCashComponent,
        canActivate: [AuthGuard, pettyCashGuard]
    },
    {
        path: 'cash-management',
        component: CashManagementComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'cash-denomination',
        component: CashDenominationComponent,
        canActivate: [AuthGuard, denominationGuard]
    },
    {
        path: 'pdf-template-tester',
        component: PdfTemplateTesterComponent,
        canActivate: [AuthGuard]
    }
];
